import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  input: {
    paddingTop: '24px',
    width: '255px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  merchantName: {
    width: '100%'
  },
  inputRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  formWrapper: {
    width: '100%'
  }
}));

